/* ═══ DN3 UGC Reels popup ═══
   Takes over [data-ugc-open] clicks and renders #dn3-reels (snippets/dn-ugc-reels.liquid).
   Data source: what theme.js initUGCFromReviews() hangs on [data-ugc-block]:
     block._ugcMedia   = [{ type:'video'|'photo', url, thumb, name, rating, ... }]
     block._ugcProduct = { title, price, compare_at, images:[...], url }
   ADD TO BAG draws no add-on popup of its own; it calls window.DN2.quickShop.open().
   Captured on window (before document capture), so it overrides the old dn2-pdp.js §9.1-1 and theme.js behaviour. */
(function () {
  'use strict';

  var root, slidesEl, railEl, progressEl, captionEl, counterEl,
      muteBtn, muteLabel, productImagesEl, titleEl, priceEl, compareEl,
      barPriceEl, barCompareEl, viewEl;
  var media = [], product = {}, index = 0, muted = true, handle = '';
  var progressFrame = 0;

  function q(sel) { return root.querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }

  function withoutSocialTags(value) {
    var original = String(value == null ? '' : value);
    var hadSocialTag = /(?:[#\uFF03][\p{L}\p{N}_]+|tiktok)/iu.test(original);
    var cleaned = original
      .replace(/[#\uFF03][\p{L}\p{N}_]+/gu, '')
      .replace(/tiktok/gi, '')
      .replace(/\s+([,.!?;:\uFF0C\u3002\uFF01\uFF1F\u3001\uFF1B\uFF1A])/g, '$1')
      .replace(/\s+/g, ' ')
      .trim();
    return hadSocialTag && /^[\p{P}\p{Sm}\p{Sc}\s]*$/u.test(cleaned) ? '' : cleaned;
  }

  function grab() {
    root = document.getElementById('dn3-reels');
    if (!root) return false;
    slidesEl = q('[data-reels-slides]');
    railEl = q('[data-reels-rail]');
    progressEl = q('[data-reels-progress]');
    captionEl = q('[data-reels-caption]');
    counterEl = q('[data-reels-counter]');
    muteBtn = q('[data-reels-mute]');
    muteLabel = q('[data-reels-mute-label]');
    productImagesEl = q('[data-reels-product-images]');
    titleEl = q('[data-reels-product-title]');
    priceEl = q('[data-reels-product-price]');
    compareEl = q('[data-reels-product-compare]');
    barPriceEl = q('[data-reels-bar-price]');
    barCompareEl = q('[data-reels-bar-compare]');
    viewEl = q('[data-reels-view]');
    return true;
  }

  /* ── render ── */
  function renderSlides() {
    var html = '';
    media.forEach(function (m, i) {
      var active = i === index ? ' is-active' : '';
      if (m.type === 'photo') {
        html += '<div class="dn3-reels__slide' + active + '" data-slide="' + i + '">' +
                '<img src="' + esc(m.url) + '" alt="' + esc(withoutSocialTags(m.name) || 'Customer photo') + '" draggable="false"></div>';
      } else {
        html += '<div class="dn3-reels__slide' + active + '" data-slide="' + i + '">' +
                '<video src="' + esc(m.url) + '"' + (m.thumb ? ' poster="' + esc(m.thumb) + '"' : '') +
                ' playsinline webkit-playsinline preload="metadata"' + (muted ? ' muted' : '') + '></video></div>';
      }
    });
    slidesEl.innerHTML = html;
    bindMediaEvents();
  }

  function renderRail() {
    if (!railEl) return;
    var html = '';
    media.forEach(function (m, i) {
      var active = i === index ? ' is-active' : '';
      var inner = m.thumb
        ? '<img src="' + esc(m.thumb) + '" alt="" loading="lazy">'
        : (m.type === 'photo'
            ? '<img src="' + esc(m.url) + '" alt="" loading="lazy">'
            : '<video src="' + esc(m.url) + '" preload="metadata" muted></video>');
      html += '<div class="dn3-reels__railthumb' + active + '" data-reels-nav="' + i + '">' + inner + '</div>';
    });
    railEl.innerHTML = html;
  }

  function renderProgress() {
    if (!progressEl) return;
    var html = '';
    media.forEach(function (m, i) {
      html += '<div class="dn3-reels__progress-dot' + (i === index ? ' is-active' : '') + '" data-reels-progress-segment="' + i + '">' +
              '<span class="dn3-reels__progress-fill"></span></div>';
    });
    progressEl.innerHTML = html;
  }

  function stopProgressLoop() {
    if (!progressFrame) return;
    cancelAnimationFrame(progressFrame);
    progressFrame = 0;
  }

  function activeVideo() {
    if (!slidesEl) return null;
    var slide = slidesEl.querySelector('.dn3-reels__slide.is-active');
    return slide ? slide.querySelector('video') : null;
  }

  function updateProgress() {
    if (!progressEl) return;
    var currentVideo = activeVideo();
    var ratio = 0;
    if (currentVideo && Number.isFinite(currentVideo.duration) && currentVideo.duration > 0) {
      ratio = Math.max(0, Math.min(1, currentVideo.currentTime / currentVideo.duration));
    }

    progressEl.querySelectorAll('.dn3-reels__progress-dot').forEach(function (segment, n) {
      var fill = segment.querySelector('.dn3-reels__progress-fill');
      var amount = n < index ? 1 : (n === index ? ratio : 0);
      segment.classList.toggle('is-active', n === index);
      if (fill) fill.style.width = (amount * 100) + '%';
    });
  }

  function startProgressLoop() {
    stopProgressLoop();
    function tick() {
      updateProgress();
      var video = activeVideo();
      if (root && root.classList.contains('is-open') && video && !video.paused && !video.ended) {
        progressFrame = requestAnimationFrame(tick);
      } else {
        progressFrame = 0;
      }
    }
    progressFrame = requestAnimationFrame(tick);
  }

  function bindMediaEvents() {
    if (!slidesEl) return;
    slidesEl.querySelectorAll('video').forEach(function (video) {
      video.addEventListener('ended', function () {
        var slide = video.closest('.dn3-reels__slide');
        if (slide && slide.classList.contains('is-active')) goTo(index + 1);
      });
      video.addEventListener('play', startProgressLoop);
      video.addEventListener('pause', updateProgress);
      video.addEventListener('loadedmetadata', updateProgress);
      video.addEventListener('durationchange', updateProgress);
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('seeked', updateProgress);
    });
  }

  function stars(n) {
    var out = '<div class="dn3-reels__stars">';
    for (var s = 1; s <= 5; s++) {
      out += '<svg width="10" height="10" viewBox="0 0 24 24" fill="' +
             (s <= (n || 5) ? '#FAFAF9' : 'rgba(250,250,249,0.3)') +
             '"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    return out + '</div>';
  }

  function renderCaption() {
    var m = media[index] || {};
    var name = withoutSocialTags(m.name) || 'Customer';
    var body = withoutSocialTags(m.body || m.text);
    var html =
      '<div class="dn3-reels__author">' +
        '<div class="dn3-reels__avatar">' + esc(name.charAt(0).toUpperCase()) + '</div>' +
        '<div style="display:flex;flex-direction:column;gap:1px;min-width:0;">' +
          '<span class="dn3-reels__author-name">' + esc(name) + '</span>' +
          '<span class="dn3-reels__author-sub">Verified buyer</span>' +
        '</div>' + stars(m.rating) +
      '</div>';
    if (body) {
      html += '<p class="dn3-reels__text">' + esc(body) + '</p>';
    }
    if (product.title) {
      html += '<div class="dn3-reels__tag">' +
        (product.images && product.images[0] ? '<img src="' + esc(product.images[0]) + '" alt="">' : '') +
        '<span>' + esc(product.title) + '</span></div>';
    }
    captionEl.innerHTML = html;
    if (counterEl) counterEl.textContent = (index + 1) + ' / ' + media.length;
  }

  function renderProduct() {
    if (productImagesEl) {
      productImagesEl.innerHTML = (product.images || []).slice(0, 2).map(function (src) {
        return '<img src="' + esc(src) + '" alt="' + esc(product.title || '') + '" loading="lazy">';
      }).join('');
    }
    if (titleEl) titleEl.textContent = product.title || '';
    if (priceEl) priceEl.textContent = product.price || '';
    if (barPriceEl) barPriceEl.textContent = product.price || '';
    var cmp = product.compare_at && product.compare_at !== product.price ? product.compare_at : '';
    if (compareEl) compareEl.textContent = cmp;
    if (barCompareEl) barCompareEl.textContent = cmp;
    if (viewEl && product.url) viewEl.setAttribute('href', product.url);
  }

  /* ── playback controls ── */
  function syncPlayback() {
    stopProgressLoop();
    slidesEl.querySelectorAll('video').forEach(function (v) {
      var active = v.closest('.dn3-reels__slide').classList.contains('is-active');
      v.muted = muted;
      if (active) {
        var p = v.play();
        if (p && p.then) p.then(startProgressLoop).catch(updateProgress);
        else startProgressLoop();
      } else {
        v.pause();
        try { v.currentTime = 0; } catch (err) {}
      }
    });
    updateProgress();
  }

  function goTo(i) {
    if (!media.length) return;
    stopProgressLoop();
    index = (i + media.length) % media.length;
    slidesEl.querySelectorAll('.dn3-reels__slide').forEach(function (el, n) {
      el.classList.toggle('is-active', n === index);
    });
    if (railEl) railEl.querySelectorAll('.dn3-reels__railthumb').forEach(function (el, n) {
      el.classList.toggle('is-active', n === index);
    });
    if (progressEl) progressEl.querySelectorAll('.dn3-reels__progress-dot').forEach(function (el, n) {
      el.classList.toggle('is-active', n === index);
    });
    renderCaption();
    updateProgress();
    syncPlayback();
  }

  /* ── open / close ── */
  function open(list, info, startIndex, productHandle) {
    if (!grab() || !list || !list.length) return;
    media = list; product = info || {}; index = startIndex || 0; handle = productHandle || '';
    renderSlides(); renderRail(); renderProgress(); renderProduct(); renderCaption();
    root.style.display = 'flex';
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('is-open'); syncPlayback(); });
  }

  function close() {
    if (!root) return;
    stopProgressLoop();
    root.classList.remove('is-open');
    slidesEl.querySelectorAll('video').forEach(function (v) { v.pause(); });
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      root.style.display = 'none';
      root.setAttribute('aria-hidden', 'true');
    }, 220);
  }

  /* ── add-on popup: reuses dn-quick-shop (left unchanged) ── */
  function openBundleSheet() {
    var h = handle ||
      (document.querySelector('[data-ugc-block]') || {}).dataset &&
      document.querySelector('[data-ugc-block]').dataset.productHandle;
    if (!h || !window.DN2 || !window.DN2.quickShop) return;
    var m = media[index] || {};
    window.DN2.quickShop.open(h, [h], 0, {
      ugc: {
        media: media.map(function (x) {
          return x.type === 'photo'
            ? { t: 'img', src: x.url }
            : { t: 'vid', src: x.url, poster: x.thumb || '' };
        }),
        name: withoutSocialTags(m.name) || 'Customer',
        index: index
      }
    });
  }

  /* ── events ── */
  document.addEventListener('click', function (e) {
    if (!root || root.style.display === 'none') return;
    if (!root.contains(e.target)) return;
    if (e.target.closest('[data-reels-close]')) { close(); return; }
    if (e.target.closest('[data-reels-atc]')) { openBundleSheet(); return; }
    if (e.target.closest('[data-reels-prev]') || e.target.closest('[data-reels-prev-btn]')) { goTo(index - 1); return; }
    if (e.target.closest('[data-reels-next]') || e.target.closest('[data-reels-next-btn]')) { goTo(index + 1); return; }
    if (e.target.closest('[data-reels-mute]')) {
      muted = !muted;
      if (muteLabel) muteLabel.textContent = muted ? 'Sound off' : 'Sound on';
      syncPlayback();
      return;
    }
    var nav = e.target.closest('[data-reels-nav]');
    if (nav) goTo(parseInt(nav.getAttribute('data-reels-nav'), 10));
  });

  document.addEventListener('keydown', function (e) {
    if (!root || root.style.display === 'none') return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') goTo(index + 1);
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') goTo(index - 1);
  });

  /* Phones swipe left/right first; the old up/down swipe is kept, decided by the dominant direction so diagonal swipes do not misfire. */
  (function () {
    var x0 = null, y0 = null;
    document.addEventListener('touchstart', function (e) {
      if (!root || root.style.display === 'none' || !root.contains(e.target) || !e.touches.length) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (x0 == null || y0 == null || !root || root.style.display === 'none' || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null; y0 = null;
      if (Math.abs(dx) >= Math.abs(dy) && Math.abs(dx) > 45) {
        goTo(index + (dx < 0 ? 1 : -1));
      } else if (Math.abs(dy) > 60) {
        goTo(index + (dy < 0 ? 1 : -1));
      }
    }, { passive: true });
    document.addEventListener('touchcancel', function () { x0 = null; y0 = null; }, { passive: true });
  })();

  /* Entry takeover: the window capture phase runs before the document capture of dn2-pdp.js / theme.js */
  window.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ugc-open]');
    if (!trigger) return;
    var block = trigger.closest('[data-ugc-block]');
    if (!block || !block._ugcMedia || !block._ugcMedia.length) return; /* data not ready → let the old behaviour through */
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    var start = 0;
    var thumb = e.target.closest('.ugc-block__thumb');
    if (thumb && thumb.parentElement) {
      var kids = Array.prototype.slice.call(thumb.parentElement.querySelectorAll('.ugc-block__thumb'));
      start = Math.max(0, kids.indexOf(thumb));
    }
    open(block._ugcMedia, block._ugcProduct, start, block.dataset.productHandle);
  }, true);

  window.DN3 = window.DN3 || {};
  window.DN3.reels = { open: open, close: close, goTo: goTo };
})();
